export const en = {
  loading: 'Loading...',
  somethingWentWrong: 'Something went wrong',
  tryAgain: 'Try Again',
  searchModule: {
    tabBasicLabel: 'Search and Book',
    tabAdvancedLabel: 'Advanced Search',
    datePickerBtnLabel: 'change date',
    activityDateLabel: 'Activity date',
    activityLabel: 'Activity',
    activityNone: 'Select activity',
    checkAvailabilityBtn: 'Check Availability',
    spaceTypeLabel: 'Space type',
    spaceTypeNone: 'Select space type',
    durationLabel: 'Duration',
    durationNone: 'Select time duration',
    comingSoon: 'Coming soon',
    advancedSearch: {
      indoor: ' Indoor',
      outdoor: 'Outdoor',
      recurrenceConfigurations: 'Recurrence Configurations',
      date: 'Date',
      recurrence: {
        title: 'Recurrence',
        daily: 'Daily',
        weekly: 'Weekly',
      },
      spaceDetails: 'Space Details',
      startDate: 'Start Time',
      onDays: 'On Days',
      endRecurrence: {
        title: 'End Recurrence',
        after: 'After',
        occurrences: 'Occurrences',
      },
      emptyResults: 'No search results',
    },
  },
  punchCards: {
    cancel: 'Cancel',
    submit: 'Register',
    successModal: {
      title: 'Congratulations',
      description: 'You are now registered for {program name} on {date}',
      mainButton: 'Thanks',
    },
  },
  time: {
    hr: 'hr',
    min: 'min',
  },
  forms: {
    gender: {
      OTHER: 'Other',
      MALE: 'Male',
      FEMALE: 'Female',
    },
    invlidMessages: {
      required: 'Required',
      enterValidePhoneNumber: 'Please enter a valide phone number',
    },
  },
  loginDialog: {
    title: 'Welcome back to Bond Sports!',
    email: 'Email Address',
    password: 'Password',
    forgotPassword: 'Forgot password',
    errorMessage: 'Email Address or Password Don’t Match',
    backToLogin: 'Back to Login',
    resetPasswordTitle: 'Reset Password',
    resetPasswordText:
      'Enter the email address you use for BondSports and we’ll send you instructions to reset you password',
    requestPasswordReset: 'Request Password Reset',
    successTitle: 'Check Your Inbox!',
    successTextWithEmail: 'We’ve sent a reset password email to',
    successText:
      'Please click the reset password link to set your new password',
    signUpTitle: 'Signup to Bond Sports',
    createAccount: 'Create Account',
    confirmPassword: 'Confirm Password',
    passwordRepeat: 'Password Repeat',
    openA: `I'm opening a`,
    toolTipTextPassword:
      'Password must be a minimum of 6 alphanumeric characters',
    // eslint-disable-next-line max-len
    toolTipTextOpenA: `If you are a sports organizer or are booking on behalf of a company, please open an organization account. You will be able to add more users to your organization's account`,
    organization: 'Organization Account',
    personal: 'Personal Account Details',
    changePassword: 'Change Password',
    skip: 'Skip',
    termsLabel: 'I Agree to Bond Sports ',
    termsAndConditions: 'Terms and Conditions',
    organizationSignUpPage: 'Organization SignUp Page',
  },
  validationErrors: {
    minPassWord: 'Minimum of 6 alphanumeric characters',
    passwordMatch: 'Passwords must match',
    invalidToken: 'Invalid Token',
    loginError: 'Email Address or Password Don’t Match',
    invalidEmail: 'Invalid Email Address',
    invalidTC: 'Please Fill Missing Details and Accept Terms & Conditions',
  },
  buttons: {
    thanks: 'Thanks',
    add: 'add',
    save: 'Save',
    edit: 'Edit',
    cancel: 'Cancel',
    continue: 'Continue',
    select: 'select',
    upload: 'Upload',
    browse: 'Browse',
    uploadFile: 'Upload File',
    back: 'Back',
    addAnotherChild: 'Add Another Child',
    pay: 'Pay',
    requestBooking: 'Request Booking',
    deposit: 'Pay Deposit',
    register: 'Register',
    acceptWaiver: 'I Accept The Waiver',
    acceptTerms: 'I Accept The terms',
    waiverConfirmation: 'Thanks',
    signAnotherWaiver: 'Sign Another',
    createTeam: 'Create Team',
    createNewTeam: 'Create a New Team',
    ok: 'Ok',
  },
  expandableText: {
    read: 'Read',
    more: 'More',
    less: 'Less',
    viewLess: 'Show less',
    viewMore: 'Show more',
  },
  user: {
    topMenu: {
      myProfile: 'My Profile',
      logout: 'Logout',
      myFamily: 'My Family',
      myTeams: 'My Teams',
      reservations: 'Reservations',
      paymentMethods: 'Payment Methods',
      passes: 'Passes',
      registration: 'Registration',
      support: 'Support',
    },
    profile: {
      gender: 'Gender',
      birthDate: 'Date of Birth',
      phoneNumber: 'Phone Number',
      emailAddress: ' Email Address',
      address: 'Address',
      street: 'Street',
      zip: 'Zip Code',
      city: 'City',
      state: 'State',
      mySports: 'My Sports',
      bio: 'Bio',
      name: 'Name',
      firstName: 'First Name',
      lastName: 'Last Name',
      selectSportTypes: 'Select Sport Types',
    },
    family: {
      addAFamilyMember: 'Add a Family Member',
      editFamilyName: 'Edit Family Name',
      addFamilyMember: 'Add Family Member',
      editFamilyMember: 'Edit Family Member',
    },
    reservation: {
      title: 'Reservations',
      table: {
        orderId: 'Order Id',
        price: 'Price',
        name: 'Name',
        facilityName: 'Facility Name',
        orderDate: 'Order Date',
        noData: 'There are no reservation for you yet',
      },
    },
    teams: {
      title: 'My Teams',
      table: {
        name: 'Name',
        noData: 'There are no teams for you yet',
      },
    },
    registration: {
      title: 'Registration',
      table: {
        orderId: 'Order Id',
        price: 'Price',
        registration: 'Registration',
        name: 'Name',
        facilityName: 'Facility Name',
        orderDate: 'Order Date',
        noData: 'There are no registration for you yet',
      },
    },
    passes: {
      noPasses: 'Ther are no passes',
      title: 'My Passes',
      participant: 'Participant',
      program: 'Program',
      product: 'Product',
      purchaseDate: 'Purchase Date',
      passesLeft: 'Passes Left',
    },
  },
  auth: {
    loginBtn: 'Login',
    signupBtn: 'Signup',
  },
  event: {
    eventName: 'Event Name',
    activity: 'Activity',
    eventType: 'Event Type',
    gender: 'Gender',
    participants: 'Participants',
    additionalInformation: 'Additional Information',
    eventLocation: 'Location',
    eventDate: 'Dates',
    eventTime: 'Days & Time',
    typeLabel: 'Event Type',
    eventTypeNone: 'Select event type',
    participantLabel: 'Participants',
    eventGenderLabel: 'Gender',
    eventInfoLabel: 'Additional Info',
    activityLabel: 'Activity',
    genderLabel: 'Gender',
    eventDetails: 'Event Details',
  },
  contact: {
    contactDetailsTitle: 'Contact Details',
    contactUs: 'Contact Us',
  },
  season: {
    seasonSchedule: 'Season Schedule',
    moreProgramSeasons: 'More seasons in this program',
    subSeason: {
      date: 'Date',
      time: 'Time',
    },
    seasonPicker: {
      selectEmpty: 'Pick your preferred registration option',
      emptyBody:
        'This program offers multiple registration options, pick one to start registering, or scroll down to see more details about each option.',
    },
    time: 'Day & Time',
    minWeek: 'Min / Week',
    earlyBirdRegistration: 'Early Bird Registration',
    regularRegistration: 'Regular Registration',
    lateRegistration: 'Late Registration',
    ends: 'Ends',
  },
  programs: {
    bookNowButtonText: 'Book now',
    comingUpTitle: 'Coming Up',
    activeSeasons: 'Active Seasons',
    pastSeasons: 'Past Seasons',
    picturesTitle: 'Pictures',
    season: {
      seasonRegistrationTitle: 'Registration',
      dates: 'Dates',
      location: 'Location',
      daysTime: 'Days & Time',
    },
    registration: {
      title: {
        earlyBird: 'Early Bird',
        regular: 'Regular',
        late: 'Late',
      },
      untilDate: 'Until',
      starts: 'Registration Starts',
      registrationOver: 'Sorry, registration is over for now',
      registrationYetStarted: 'The registration is not open yet, starts at ',
    },
    other: 'other',
    type: {
      camps: 'Camps',
      classes: 'Classes',
      clinics: 'Clinics',
      lessons: 'Lessons',
      tournaments: 'Tournaments',
      clubs: 'Clubs',
    },
  },
  memberShip: {
    registrationTitle: 'Membership Registration',
    registerNow: 'Register Now',
    registrationEnd: 'Registration End',
    registrationPrice: 'Registration Price',
    until: 'Until',
    renewal: 'Renewal Frequency',
    moreMembership: 'More Membership',
    monthly: 'Monthly',
    quarterly: 'Quarterly',
    annually: 'Annually',
    price: 'Price',
    duration: 'Duration',
  },
  checkout: {
    title: 'Book Your Experience',
    progress: {
      package: 'Package',
      schedule: 'Schedule',
      addons: 'Add Ons',
      details: 'Details',
      application: 'Application',
      insurance: 'Insurance',
      payment: 'Payment',
      teams: 'Teams',
      familyMembers: 'Family Members',
    },
    teams: {
      title: 'My Teams',
      createYourTeam: 'Create Your Team',
      stepValidationError: 'Please select a team',
      form: {
        dragImageOr: 'Drag the image here or',
        backgroundImg: 'Background Image',
        logoImage: 'Logo image',
        teamName: 'Team Name',
        teamDescription: 'Team Description',
        ageRange: 'Age Range',
        levelOfPlay: 'Level Of Play',
        city: 'City',
        advancedSettings: 'Advanced Settings',
      },
    },
    details: {
      chooseWhoYouReg: "Choose who you're registering",
      stepValidationError: 'Please select a family member.',
      genericStepValidationError: 'Server error.',
      eventFormTitle: 'Event Details',
      addMembershipTitle: 'Add membership to cart',
      addMembershipSubtitle:
        'Hey, in order to complete registration to our activity, Please purchase one of the memberships',
      dates: 'Dates',
      pleaseChooseUpto: 'Please choose up to',
      members: ' members',
      youMustChoose: 'You must choose exactly ',
      youMustChooseAtLease1: 'You must choose at least 1 member',
    },
    addons: {
      addons: 'Add Ons',
      selectAddons: 'Select Add Ons',
      chooseAddons: 'Choose your Add Ons',
      mandatory: 'Mandatory',
      stepValidationError: 'Please choose all the mandatory addons',
      for: 'for',
    },
    application: {
      application: 'Application',
      termsAndConditions: 'Terms & Condition',
      terms: 'Terms',
      waiver: 'Waiver',
      facilitiesQuestionnaire: "Facilities' Questionnaire",
      agreeTo: 'I Agree to',
      selectShirtSize: 'Select Shirt Size',
      select: 'Select',
      yes: 'Yes',
      no: 'No',
      stepValidationError: 'Please fill all required fields.',
      address: { city: 'City', state: 'State', zipCode: 'Zip Code' },
    },
    cart: {
      orderSummary: 'Order Summary',
      itemsInCart: 'Items in Cart',
      bookingFee: 'Booking Fee',
      total: 'Total',
      add: 'Add To Cart',
      hour: 'hr',
      hours: 'hrs',
      startingFrom: 'Starting From',
      noItems: 'No Items Added To Cart',
      membership: 'Membership',
      addMembership: 'Add Membership To Cart',
    },
    leagues: {},
    schedule: {
      selectEventsTitle: 'Pick your schedule',
      selectEventsTitlePunchCardAvailable:
        'You may pick the schedule you wish to attend now, or redeem your purchase later. You may also redeem part of your purchase now.',
      stepValidationError: 'Please pick your schedule.',
      pleasSelect: 'Please select exactly',
      eventsOrClasses: 'event',
      manyEventsOrClasses: 'events',
      filter: 'filter',
    },
    package: {
      selectPackageTitle: 'Select Package',
      packagePrice: 'Price',
      stepValidationError: 'Please select a package.',
      na: 'N/A',
    },
    space: {
      selectDateTitle: 'Select Date',
      selectSpace: 'Select Space',
      selectTimeSlots: 'Select Time Slots',
      noAvailableSlots: 'No available slots',
      pleaseSelectTimeSlots: 'Please select time slots',
    },
    payment: {
      paymentMethods: 'Payment Methods',
      addCustomerPaymentMethod: 'Add customer payment method',
      addBankAccount: 'Add Bank Account',
      addBankAccountDetails: 'Please add bank account details',
      selectPaymentMethodTitle: 'Select Payment Method',
      addNewCreditCardText: 'Add a new credit card',
      addNewBankAccountText: 'Add a new bank account',
      orderDetails: {
        title: 'Order Details',
        reservationName: 'Reservation Name',
        startDate: 'Start Date',
        eventDate: 'Event Date',
        registeredMembers: 'Registered Members',
        reservationID: 'Reservation ID',
        sportType: 'Sport Type',
        facility: 'Facility',
        price: 'Price',
      },
      card: {
        nameOnCard: 'Name on Card',
        defaultCard: 'Default',
        expirationDate: 'Expiration',
        creditCardDetails: 'Credit or Debit Card Details',
        holderName: 'Card Holder Name',
        number: 'Card Number',
        securityCode: 'Security Code',
        addPaymentMethod: 'Add Payment Method',
        billingAddress: 'Billing Address',
        saveCreditCardToProfile: 'Save credit card to profile',
        savecreditcardAsDefault: 'Save credit card as default',
      },
      done: {
        title: 'You’re All Set! See you out there!',
        message: '',
        myReservations: 'Take Me To My Orders',
        myArea: 'Take Me To My Area',
      },
      deposit: {
        title: 'Pay Deposit',
        subTitle: 'You may choose to pay any sum with a minimum of $',
        inputLabel: 'The amount you choose to pay',
        errorLabel: 'You must pay a minimum of $',
      },
      free: { title: 'Select Your Payment Method' },
      stepValidationError: 'Please select a payment method.',
    },
  },
  organization: {
    title: 'Organization',
  },
  feedRow: {
    buttons: {
      shareText: 'Share',
      favoriteText: 'Favorite',
    },
  },
  spaces: {
    spaces: 'Spaces',
    moreSpaces: 'More spaces at this facility',
    pricing: {
      title: 'Pricing',
      addonTitle: 'Addons',
      startFrom: 'starting from',
      shortHour: 'HR',
      fullDay: 'Full',
    },
    location: {
      title: 'Location',
    },
  },
  facilities: {
    openingHours: {
      title: 'Opening Hours',
    },
    amenities: {
      title: 'Amenities',
    },
    location: {
      title: 'Location',
    },
  },
  gallery: {
    pictures: 'Pictures',
  },
  leagues: {
    pastSeasons: 'Past seasons',
    upcomingSeasons: 'Coming up',
    activeSeasons: 'Active seasons',
    comingUp: 'Coming Up',
    status: 'Status',
    registraionOpen: 'Registration open',
    registraionOpens: 'Registration opens',
    emptySeason: 'Select Season',
    startingAt: 'Starting at',
    otherLeagues: 'Other leagues',
    registrationOpen: 'Registration open',
    registrationOpens: 'Registration opens',
    leagueOrganizer: 'League Organizer',
    aboutLeague: 'About League',
    individual: 'Individual',
    team: 'Team',
  },
  waiver: {
    title: 'Waiver',
    family: { title: 'Who are you signing Waiver for?' },
    Questionnaire: { title: 'Please Complete the Questionnaire' },
    formValidationError: 'Please fill all required fields.',
    confirmation: {
      title: 'Waiver Confirmation',
      thanks: 'Thanks!',
      formValidation: 'Your waiver form is valid for 1 year',
      memberName: 'Name',
      WaiverDate: 'Waiver Date',
    },
    cancel: 'cancel',
  },
  leagueSeasons: {
    registraion: 'Registration',
    division: 'Division',
    standings: 'Standings',
    gamesPlayed: 'GP',
    wins: 'W',
    loses: 'L',
    draws: 'D',
    winPercentage: 'PCT',
    pontsDifference: 'PD',
    showAllStandings: 'Show all standings',
    theTeams: 'The teams',
    viewMore: 'View more',
    viewLess: 'View less',
    aboutSeason: 'About season',
    activeSeasons: 'Active seasons games',
    teams: 'Teams',
    date: 'Date',
    time: 'Time',
    vs: 'vs.',
    location: 'Location',
    showMore: 'Show More',
    showLess: 'Show Less',
    otherSeasons: 'Other seasons in',
  },
  NumberRange: {
    title:
      'Between (You may search a time frame that is larger than your event duration)',
    from: 'from',
    to: 'to',
    am: 'AM',
    pm: 'PM',
  },
  levelsOfPlay: {
    semiPro: 'SEMI_PRO',
    advanced: 'ADVANCED',
    intermediate: 'INTERMEDIATE',
    beginner: 'BEGINNER',
  },
  longDescriptionTitle: 'About',
  team: {
    inviteMembers: 'invite members',
    members: 'Members',
    pendingInvites: 'Pending invites',
    people: 'People',
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email',
    phoneNumber: 'Phone Number',
    add: 'Add',
    sendInvite: 'Send invite',
    teamMembers: 'Team Members',
    goBack: 'go back to team page',
    events: 'Events',
    pastEvents: 'Past Events',
    upcomingEvents: 'Upcoming Events',
    noPastEvents: 'No Past Events',
    noUpcomingEvents: 'No Upcoming Events',
    eventName: 'Event Name',
    location: 'Location',
    date: 'Date',
    time: 'Time',
    noTeamMembers: 'There are currently no members on this team',
    inviteError: 'Oops… looks like we have a problem sending the team invites',
    inviteSuccess: {
      title: 'Awesome, we’ve sent an email to your team members',
      details: 'and you will be notified when they join the team',
    },
    iviteFailure: 'Oops… looks like we have a problem sending the team invites',
    familyMember: 'Please choose a family member',
    thankForJoining: 'Thanks for joining',
    completeRegistration: 'Complete your registration.',
    join: 'Join',
    application: {
      teamRegistered: 'Your team has registered to',
      completeapplicationForm: 'Complete their application form',
      acceptApplication: 'I accept the appication',
      warning:
        'If you are a youth team coach, and want to invite your own family member, please send the invite to a different email address',
    },
    notPermittedUser: "Sorry, Invite can't be used",
    joinTeamError: "You're not allowed to join the team",
    usedTokenError:
      'Sorry, this is invite is no longer valid, please ask your captain or coach to send a new invite to the team',
  },
  errorDetails: 'Please try again, or contact support@bondsports.co',
  detailsChangedAlert: {
    titel: 'Your details changed',
    details: 'We notice you changed your details.',
    saveProfile: 'Do you want to save the changes to your profile?',
    yesUpdate: 'Yes, update',
    noLeaveIt: 'No, leave it',
  },
  currency: {
    USD: {
      symbol: '$',
    },
  },
  freeRegistrationBox: {
    freeOfCharge: 'Free of Charge',
    thisOneIsOnUs: 'This one is on us, free of charge',
    enjoy: 'ENJOY the activity and come back soon',
  },
  paymentTypeLable: {
    addPayment: 'Add Payment',
    creditCard: 'Credit card',
    bankAccount: 'Bank account',
    enterManual: 'Enter manual',
    enterInstant: 'Enter instant',
    acountBalance: 'Account balance',
    cash: 'Cash',
  },
  address: { city: 'City', state: 'State', zipCode: 'Zip Code' },

  generalError: {
    title: 'Something went wrong',
    info: 'We take care of it',
  },
  tvMonitor: {
    today: 'TODAY',
    time: 'TIME',
    configurationError: 'Sorry not valid configuration, please contact support',
  },
  websiteSchedule: {
    yetPublished: 'has not yet published the schedule for ',
    emptyState: 'Seems like there are no events on this day',
    daily: 'Daily',
    weekly: 'Weekly',
    today: 'Today',
    pickYourProgram: 'Pick Your Program',
    yetPublishedShort: 'Yet Published',
  },
  paymentPlanModal: {
    title: 'Pay Deposit',
    description: 'Choose to pay any sum with a minimum of ',
    inputLabel: 'The amount you choose to pay',
    PaymentPlan: 'Payment Plan',
    cancel: 'Cancel',
    apply: 'Apply',
    due: 'Due Later',
    selectLabel: 'Number of payments',
    every: 'Every',
    ofTheMonth: 'of the month',
    st: 'st',
    th: 'th',
    step2: {
      title: 'Payment Plan',
      chargingDeposit: 'Charging deposit',
      payments: 'payments',
      each: 'each',
      date: 'Date',
      amount: 'Amount',
      pay: 'pay',
    },
  },
};
